'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Heart = require('./Heart');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Heart).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Heart/index.js
// module id = 1204
// module chunks = 1